export const ROUTES_CONSTANTS = {
  NO_ROUTE: "/",
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  SET_PASSWORD: "/set-password",

  // Super Admin routes
  COMPANY_MANAGEMENT: "/super-admin/company-management",
  REGISTER_COMPANY: "/super-admin/company-management/register",
  COMPANY_DETAIL: "/super-admin/company-management/detail",
  UPDATE_COMPANY: "/super-admin/company-management/update",

  // Company routes
  COMPANY_DASHBOARD: "/company/dashboard",
  USERS: "/company/users",
  INVITE_USER: "/company/users/invite",
  UPDATE_USER: "/company/users/update",
  PERMISSIONS: "/company/permissions",
  CREATE_PERMISSION: "/company/permissions/create",
  UPDATE_PERMISSION: "/company/permissions/update",
  PERMISSION_GROUPS: "/company/permission-groups",
  CREATE_PERMISSION_GROUP: "/company/permission-groups/create",
  UPDATE_PERMISSION_GROUP: "/company/permission-groups/update",

  // User Routes
  DASHBOARD: "/dashboard",
};
